import React from 'react';
import { NotificationProvider } from '@ipc/ipc-components';
import {
  Router, Route, LanguageProvider, LanguageRouting,
} from '@ipc/ipc-core';
import { Provider } from 'react-redux';
import * as PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { AppIntlProvider } from './common/AppIntlProvider';
import { defaultLanguage, supportedLanguages } from '../locales/locales';
import AppContainer from './application/AppContainer';

const AppLanguageRouting = (props) => <LanguageRouting {...props} AppContainer={AppContainer} />;

const Root = (props) => {
  const { store } = props;
  return (
    <ThemeProvider theme={{}}>
      <LanguageProvider supportedLanguages={supportedLanguages} defaultLanguage={defaultLanguage}>
        <Provider store={store}>
          <NotificationProvider>
            <Router basename={process.env.basePath}>
              <AppIntlProvider>
                <Route component={AppLanguageRouting} />
              </AppIntlProvider>
            </Router>
          </NotificationProvider>
        </Provider>
      </LanguageProvider>
    </ThemeProvider>
  );
};

Root.propTypes = {
  store: PropTypes.objectOf(PropTypes.shape),
};

export default Root;
